import { render, staticRenderFns } from "./WizardStepsList.vue?vue&type=template&id=6bc32798&"
import script from "./WizardStepsList.vue?vue&type=script&lang=js&"
export * from "./WizardStepsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports